module.exports = __webpack_public_path__ + "static/media/image-03.bc7056e8.jpg";